import { useState, useCallback } from 'react'

export { useSection }

function useSection(initialSection = 0) {
  const [activeSection, setActiveSection] = useState(initialSection)

  const changeSection = useCallback((index: number) => {
    setActiveSection(index)
  }, [])

  const toggleSection = useCallback((index: number) => {
    setActiveSection(prev => prev === index ? null : index)
  }, [])

  return {
    activeSection,
    changeSection,
    toggleSection,
    isActive: (index: number) => activeSection === index
  }
}

export default useSection
